import { TourPractice } from "./TourPractice";

const steps = [
  { target:"impressoras-form", title:"Cadastre sua impressora", text:"Informe nome e modelo, por exemplo Anycubic Kobra X. Use seus valores reais de energia e desgaste por hora para calcular o custo. Adicionar salva de verdade; se já cadastrou sua impressora, basta continuar." },
  { target:"impressoras-lista", title:"Sua produção organizada", text:"Aqui ficam as impressoras cadastradas e seus estados. Marque a mais usada para facilitar a seleção. No fatiamento, confira sempre o perfil compatível com o modelo cadastrado." },
];
export function TourImpressoraInteractive({ onDone }) {
  return <TourPractice steps={steps} onDone={onDone} />;
}
